import { UiPowerUpModel } from "../../models";
import {
    mockAdfDocument,
    mockAdfParagraph,
    mock$AssetModel,
    mockAdfText,
    mockUiButtonModelContent,
    mockUiButtonModel,
    mockLinkButtonThemeModel,
    mockLinkButtonThemeModelContent
} from "../index";

import { mockUiImageModel, mockUiImageModelContent } from ".";

export function mockUiPowerUpModel({
    id = "power-up-1234",
    type = "uiPowerUp",
    locale = "en",
    content = mockUiPowerUpModelContent()
}: Partial<UiPowerUpModel> = {}): UiPowerUpModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiPowerUpModelContent = UiPowerUpModel["content"];

export function mockUiPowerUpModelContent({
    title = "Google Drive",
    description = mockAdfDocument({
        content: [
            mockAdfParagraph({
                content: [
                    mockAdfText({
                        text: "Keep files organized alongside your projects."
                    })
                ]
            })
        ]
    }),
    button = mockUiButtonModel({
        id: "test",
        type: "uiButton",
        locale: "en",
        content: mockUiButtonModelContent({
            entryTitle: "Add Power-Up Button",
            text: "Add Power-Up",
            url: "/foo",
            buttonTheme: mockLinkButtonThemeModel({
                id: "secondary-outline-reduced",
                type: "linkButtonTheme",
                locale: "en",
                content: mockLinkButtonThemeModelContent({
                    title: "secondary outline reduced",
                    appearance: "Secondary",
                    style: "Outline",
                    prominence: "Reduced"
                })
            })
        })
    }),
    logo = mockUiImageModel({
        id: "google-drive-icon",
        type: "uiImage",
        locale: "en",
        content: mockUiImageModelContent({
            image: mock$AssetModel({
                title: "Google Drive",
                url: "/ui-power-up/google-drive.png",
                width: 240,
                height: 240
            })
        })
    })
}: Partial<UiPowerUpModelContent> = {}): UiPowerUpModelContent {
    return {
        title,
        description,
        button,
        logo
    };
}
